import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, computed, DestroyRef, effect, ElementRef, HostListener, Inject, inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet'
import { MatFormFieldModule } from '@angular/material/form-field'
import { GetAllReviewsPayloadModel, GetAllVotesEcolodgePayloadModel, GetAllVotesPayloadModel } from '@core/models/domains/comments'
import { HotelRepository } from '@core/services/repositories/hotel.repository'
import { SearchBoxService } from '@shared/services/serach-box.service'
import { cdnUrl, WINDOW } from 'apps/ihowebsite/src/app/app.module';
import { BehaviorSubject } from 'rxjs'
import { HotelInfoUiService } from '../accommodation-info/services/hotel-info-ui.service'
import { LoadingService } from '@shared/services/loading.service'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { FormsModule } from '@angular/forms'
import { SharedModule } from '@shared/shared.module'
import { ProgressbarComponent } from '@shared/components/progressbar/progressbar.component'
import { MatSelectModule } from '@angular/material/select'
import { HotelReviewFilter } from '@core/models/domains/reviews'
import { ActivatedRoute, Router } from '@angular/router'
import { PaginationComponent } from '@shared/components/pagination/pagination.component'

@Component({
  selector: 'iho-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
  standalone: true,
  providers: [HotelInfoUiService],
  imports: [
    CommonModule,
     MatCheckboxModule,
     FormsModule,
     SharedModule,
     ProgressbarComponent,
     MatFormFieldModule,
     MatSelectModule,
     PaginationComponent
]
})

export class ReviewsComponent implements OnInit {
    selectedOrder: number = 4;
  listBreadcrumb: any;
     selectedType: number = 0;
     loadingData = false;
     noData = false;
     showFiltersComments: boolean = false;
     showEmpty = false;
     showRemoveBtn = false;
     isScoreAccordionOpen = true;
     cdnUrl = cdnUrl;
     listVoteAll: any[] = [];
     pageSize: number = 10;
     destroy = BehaviorSubject<boolean>;
    queryParams: any;
     pageIndex = 1;
     flagScroll = false;
     totallCount = 0;
     loadingScroll = false;
     filterTextsModel: string[] = [];
     filterScoreModel: number[] = [];
     filterSeasonsModel: number[] = [];
         route = inject(ActivatedRoute);
          router = inject(Router);
     @ViewChild('showFiltersCommentsTemplate') showFiltersCommentsTemplate!: any;
     @ViewChild('showFiltersScoreTemplate') showFiltersScoreTemplate!: any;
     @ViewChild('showFiltersDateTemplate') showFiltersDateTemplate!: any;
     @ViewChild('containerComments') containerComments!: ElementRef;
     modalData!: any;
     guestScore = [
      { id: 1, title: '1 (ضعيف)', score: '۱', label: 'ضعيف', selected: false },
      { id: 2, title: '2 (متوسط)', score: '۲', label: 'متوسط', selected: false },
      { id: 3, title: '3 (خوب)', score: '۳', label: 'خوب', selected: false },
      { id: 4, title: '4 (بسيار خوب)', score: '۴', label: 'بسيار خوب', selected: false },
      { id: 5, title: '5 (عالى)', score: '۵', label: 'عالي', selected: false },
     ];
     historyComments = [
      { id: 1, title: 'فروردين تا خرداد', line1: 'فروردين', line2: 'تا خرداد', selected: false },
      { id: 2, title: 'تير تا شهريور', line1: 'تير', line2: 'تا شهريور', selected: false },
      { id: 3, title: 'مهر تا آذر', line1: 'مهر', line2: 'تا آذر', selected: false },
      { id: 4, title: 'دي تا اسفند', line1: 'دي', line2: 'تا اسفند', selected: false },
     ];
     listRoomsFilters: any;
     constructor(
      public InfoService: HotelInfoUiService,
      public _bottomSheet: MatBottomSheet,
      public LoadingService: LoadingService,
      private destroyRef: DestroyRef,
      @Inject(PLATFORM_ID) public platformId: Object,
        @Inject(WINDOW) public window: Window,
     ) {
       this.queryParams = this.route.snapshot.queryParams;
         
     }

     private searchBoxService = inject(SearchBoxService);
     accommodation = computed(() => this.searchBoxService.accommodation());
    
     ngOnInit(): void {
      if (this.isEcolodgeReviews()) {
        this.searchBoxService.accommodation.set('ecolodge');
      }
      this.getFilters();
     }
   
     closeBottomSheet() {
      this._bottomSheet.dismiss();
     }
     private isEcolodgeReviews(): boolean {
      return this.route.snapshot.data?.['accommodation'] === 'ecolodge'
        || this.router.url.split('?')[0].includes('/ecolodge/');
     }

     getFilters() {
      
       this.route.paramMap.subscribe((params: any) => {
         this.loadHotelReviews(params.params);
       });
     }

     private loadHotelReviews(params: { slug1: string; slug2: string }, pageIndex?: number) {
       const isEcolodge = this.isEcolodgeReviews();
       const peyload: HotelReviewFilter = {
         travelType: 0,
         VoteSortType: 4,
         filterTexts: '',
         voteScores: 0,
         voteSeasons: 0,
         pageSize: this.pageSize,
         pageIndex: pageIndex ?? (this.queryParams['page'] ? (+this.queryParams['page']) : 1),
         hotelName: params.slug2,
         cityName: isEcolodge ? params.slug1 : params.slug1.replace(/-hotels$/, '')
       };
       this.InfoService.getReviewsHotels(peyload, isEcolodge)
       .pipe(takeUntilDestroyed(this.destroyRef))
       .subscribe((res: any) => {
        this.modalData = res;
         this.listBreadcrumb = res.breadCrumbs;
       this.listRoomsFilters = res.vote;
         this.listVoteAll = res.vote.votes;
         this.loadingData = false;
         this.LoadingService.loadingState.set(false);
       });
     }
     getVotesAll(type: string, pageSize: number, pageIndex: number) {
      if (type == 'mobile' && pageIndex == 1) {
       this.listVoteAll = [];
      }
      if (type == 'mobile' && pageIndex != 1) {
       pageIndex = 1;
      }
       let model: GetAllReviewsPayloadModel = {
         hotelId: this.modalData.hotelId,
       pageIndex: pageIndex,
       pageSize: pageSize,
       travelType: this.selectedType,
       filterTexts: this.filterTextsModel,
       voteScores: this.filterScoreModel,
       voteSeasons: this.filterSeasonsModel,
       VoteSortType: this.selectedOrder
      };
      
      if (this.pageIndex == 1) this.loadingData = true;
    
      this.LoadingService.loadingState.set(true);
      this.flagScroll = true;
      if (this.listVoteAll.length == this.totallCount && this.totallCount != 0) {
       return;
      }
    
      this.loadingScroll = true;
       this.InfoService.getVoteReviews(model).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
       this.totallCount = res.count;
       this.flagScroll = false;
       this.loadingScroll = false;
       this.loadingData = false;
       res.votes?.forEach((el: any) => {
        el.arrivalDate = new Date(el.arrivalDate).toLocaleDateString('fa-IR', {
         dateStyle: 'short',
         numberingSystem: 'latn',
        });
       });
         this.listVoteAll = res.votes;
       if (this.listVoteAll?.length > 0) {
        this.LoadingService.loadingState.set(false);
       }
       this.showEmpty = false;
       if (res.votes?.length == 0) {
        this.showEmpty = true;
       }
       if (type == 'mobile') this.closeBottomSheet();
      });
    
     }
     getVotesAllEcolodge(type: string, pageSize: number, pageIndex: number) {
      if (this.noData) return;
      if (type == 'mobile' && pageIndex == 1) {
       this.listVoteAll = [];
      }
      if (type == 'mobile' && pageIndex != 1) {
       pageIndex = 1;
      }
      let model: GetAllVotesEcolodgePayloadModel = {
       hotelId: this.modalData.hid,
       HouseId: this.modalData.HouseId,
       PageIndex: pageIndex,
       PageSize: pageSize,
       Type: this.modalData.type,
      };
      if (this.pageIndex == 1) this.loadingData = true;
    
      this.LoadingService.loadingState.set(true);
      this.flagScroll = true;
      if (this.listVoteAll.length == this.totallCount && this.totallCount != 0) {
       return;
      }
    
      this.loadingScroll = true;
      this.InfoService.getVoteAllEcolodge(model).subscribe((res: any) => {
       this.totallCount = res.count;
       this.flagScroll = false;
       this.loadingScroll = false;
       this.loadingData = false;
       if (res.votes.length == 0) {
        this.noData = true;
        return;
       }
       res.votes?.forEach((el: any) => {
        el.arrivalDate = new Date(el.arrivalDate).toLocaleDateString('fa-IR', {
         dateStyle: 'short',
         numberingSystem: 'latn',
        });
       });
       this.listVoteAll.push(...res.votes);
       if (this.listVoteAll?.length > 0) {
        this.LoadingService.loadingState.set(false);
       }
       this.showEmpty = false;
       if (res.votes?.length == 0) {
        this.showEmpty = true;
       }
       if (type == 'mobile') this.closeBottomSheet();
      });
    
     }
    
     selectedScore(id: number, type: string) {
      this.filterScoreModel = [];
      this.guestScore.forEach((item) => {
       if (item.selected) {
        this.filterScoreModel.push(item.id);
       }
      });
      this.pageIndex = 1;
      if (type != 'mobile') {
       this.listVoteAll = [];
       this.getVotesAll('desk', this.pageSize, 1);
      }
      if (this.filterScoreModel?.length) this.showRemoveBtn = true;
      else this.showRemoveBtn = false;
     }
     selectedHistoryComments(id: number, type: string) {
      this.filterSeasonsModel = [];
      this.historyComments.forEach((item) => {
       if (item.selected) {
        this.filterSeasonsModel.push(item.id);
       }
      });
    
      this.pageIndex = 1;
      if (type != 'mobile') {
       this.listVoteAll = [];
       this.getVotesAll('desk', this.pageSize, 1);
      }
      if (this.filterSeasonsModel?.length) this.showRemoveBtn = true;
      else this.showRemoveBtn = false;
     }
     selectedLabels(text: string, type: string) {
      this.filterTextsModel = [];
      this.listRoomsFilters.voteFilterLabels.forEach((item: any) => {
       if (item.name == text) {
        item.selected = !item.selected;
       }
       if (item.selected) {
        this.filterTextsModel.push(item.name);
       }
      });
      this.pageIndex = 1;
      if (type != 'mobile') {
       this.listVoteAll = [];
       this.getVotesAll('desk', this.pageSize, 1);
      }
      if (this.filterTextsModel?.length) this.showRemoveBtn = true;
      else this.showRemoveBtn = false;
     }
     selectedTypes(ev: any) {
      this.listVoteAll = [];
      this.pageIndex = 1;
      this.getVotesAll('desk', this.pageSize, 1);
      this.showRemoveBtn = true;
     }
     get quotedAddDatePersian(): string {
      return `"${this.modalData?.labelHotelReview.addDatePersian}"`;
    }
     showFiltersSec(config?: MatBottomSheetConfig) {
      this._bottomSheet.open(this.showFiltersCommentsTemplate, config);
     }
     showFiltersScore(config?: MatBottomSheetConfig) {
      this._bottomSheet.open(this.showFiltersScoreTemplate, config);
     }
     showFiltersDate(config?: MatBottomSheetConfig) {
      this._bottomSheet.open(this.showFiltersDateTemplate, config);
     }
     removeFilters() {
      this.guestScore.forEach((item) => {
       item.selected = false;
      });
      this.historyComments.forEach((item) => {
       item.selected = false;
      });
      this.listRoomsFilters.voteFilterLabels.forEach((item: any) => {
       item.selected = false;
      });
      this.filterSeasonsModel = [];
      this.filterTextsModel = [];
      this.filterScoreModel = [];
      this.selectedType = 0;
       this.selectedOrder = 0;
      this.showRemoveBtn = false;
      this.listVoteAll = [];
      this.pageIndex = 1;
      this.getVotesAll('desk', this.pageSize, 1);
     }
  onPaginate(page: number) {
    this.router.navigate([], {
      queryParams: {
        ...this.queryParams, 
        page
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
 
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.queryParams = this.route.snapshot.queryParams;
        if (this.isEcolodgeReviews()) {
          this.loadHotelReviews(this.route.snapshot.params as { slug1: string; slug2: string }, page);
        } else {
          this.getVotesAll('desk', this.pageSize, page);
        }
        this.window.scrollTo({
          top: 600,
          behavior: 'smooth',
        });
      }, 10);
    }

    }

  toggleScoreAccordion() {
    this.isScoreAccordionOpen = !this.isScoreAccordionOpen;
  }

  getCircleProgress(score: string | number | null | undefined): number {
    const value = Number(score);
    if (!Number.isFinite(value) || value <= 0) return 0;
    return Math.min((value / 5) * 100, 100);
  }

  toggleGuestScore(item: { id: number; selected: boolean }) {
    item.selected = !item.selected;
    this.selectedScore(item.id, 'desk');
  }

  toggleHistoryComment(item: { id: number; selected: boolean }) {
    item.selected = !item.selected;
    this.selectedHistoryComments(item.id, 'desk');
  }

}
